export default __webpack_public_path__ + "static/media/2.42ce0f64.jpg";